import { render, staticRenderFns } from "./listv2.vue?vue&type=template&id=8bf3261a&scoped=true&"
import script from "./listv2.vue?vue&type=script&lang=js&"
export * from "./listv2.vue?vue&type=script&lang=js&"
import style0 from "./listv2.vue?vue&type=style&index=0&id=8bf3261a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf3261a",
  null
  
)

export default component.exports